import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * Lista de barras horizontales reutilizable (marcadores, señales, etc.).
 * Barras a ancho completo (sin animacion de crecimiento, robusto en cualquier
 * entorno); el valor puede animarse con CountUp desde la vista.
 *
 * @param {Array} items - { label, sub?, pct, value, color?, strong? }
 *   `strong` remarca la fila dominante (label/valor en navy/primary y peso 500)
 *   para dar jerarquia cuando una razon domina claramente sobre el resto.
 */
function BarList({ items }) {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
            {items.map((it, i) => (
                <Box
                    key={i}
                    sx={{
                        display: "grid",
                        gridTemplateColumns: { xs: "110px 1fr 46px", sm: "150px 1fr 52px" },
                        alignItems: "center",
                        gap: 1.5,
                    }}
                >
                    <Box>
                        <Typography sx={{ fontSize: 13, fontWeight: it.strong ? 500 : 400, color: "text.primary", lineHeight: 1.2 }}>
                            {it.label}
                        </Typography>
                        {it.sub && <Typography sx={{ fontSize: 11, color: "text.secondary" }}>{it.sub}</Typography>}
                    </Box>
                    <Box sx={{ height: 10, borderRadius: 5, bgcolor: "divider", overflow: "hidden" }}>
                        <Box sx={{ height: "100%", width: `${it.pct}%`, bgcolor: it.color || "primary.main", borderRadius: 5 }} />
                    </Box>
                    <Typography
                        sx={{ fontSize: 14, fontWeight: it.strong ? 500 : 400, color: it.strong ? "primary.main" : "text.primary", textAlign: "right" }}
                    >
                        {it.value}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
}

export default BarList;
